import { VoicePreviewPayload } from 'shared';
import { textToSpeechApi } from '../api';

export const getEstimatedCredits = async (payload: VoicePreviewPayload) => {
  const { data } = await textToSpeechApi(payload);

  return data.totalCredits;
};
